/*
 * @fileOverView buttonloader component definition
 */

import Vue from 'vue';

Vue.component('buttonloader-vue', {
  // Tracks whether the parent form is valid to toggle display of feedback.
  props: [
    'isLoading'
  ],

  data: function() {
    return {
      loading: false
    }
  },

  watch: {
    isLoading: function (val) {
      this.loading = val;
    }
  },

  methods: {
    handleClick() {
      // In cases where the button isn't in a form, such as a standalone
      // preview, the isLoading prop will be undefined.
      this.loading = typeof this.isLoading === 'undefined' || this.isLoading;
    }
  }
})
